{
  "title": "Campaigns",
  "subtitle": "A banner beneath the signature, between two dates. Set the dates and it appears and disappears on its own — nobody has to remember to take it down.",
  "newCampaign": "New campaign",
  "emptyTitle": "No campaigns",
  "emptyBody": "A campaign fills the banner slot in a signature template. Add the slot in the designer first, or the banner has nowhere to appear.",
  "liveNow": "Live now",
  "noBanner": "No banner",
  "statusDraft": "Draft",
  "statusScheduled": "Scheduled",
  "statusActive": "Active",
  "statusRunning": "Running",
  "statusPaused": "Paused",
  "statusEnded": "Ended",
  "edit": "Edit",
  "pause": "Pause",
  "resume": "Resume",
  "schedule": "Schedule",
  "startNow": "Start now",
  "end": "End",
  "delete": "Delete",
  "deleteConfirm": "Delete this campaign?",
  "name": "Name",
  "namePlaceholder": "Spring Roadshow",
  "starts": "Starts",
  "ends": "Ends",
  "banner": "Banner",
  "chooseBanner": "Choose banner",
  "chooseImage": "Choose an image",
  "changeImage": "Change image",
  "removeBanner": "Remove",
  "bannerHint": "Design for 600px wide — that matches the default banner slot. Height is flexible; about 100px is typical. A campaign with no banner renders nothing, whatever its schedule says.",
  "link": "Link",
  "linkDescription": "Where a click goes. Wrapped in a tracking redirect at send time.",
  "linkPlaceholder": "https://example.com/offer",
  "linksTo": "Links to {{url}}",
  "altText": "Alt text",
  "altTextDescription": "Read aloud by screen readers, and shown by clients that block images — which is most of them by default.",
  "timezoneHint": "Times are in your local timezone. Leave the end empty for a banner that runs until somebody stops it.",
  "createDraft": "Create draft",
  "save": "Save",
  "saveCampaign": "Save campaign",
  "createTitle": "New campaign",
  "editTitle": "Edit campaign",
  "saved": "Campaign saved.",
  "createdDraft": "Created as a draft. Schedule it or start it when you are ready.",
  "saveError": "Could not save that.",
  "deleted": "{{name}} deleted.",
  "deleteError": "Could not delete that campaign.",
  "statusUpdated": "Campaign {{verb}}.",
  "statusError": "Could not change that.",
  "actionsAria": "Actions for {{name}}",
  "windowNoDates": "No dates set — it will only run if started by hand.",
  "windowFromOpen": "From {{starts}}, until somebody ends it.",
  "windowUntil": "Until {{ends}}.",
  "windowRange": "{{starts}} to {{ends}}."
}
